import { css as e } from "styled-components";
const s = {
  space: /* @__PURE__ */ e([
    "margin:0;padding:0;"
  ]),
  list: {
    item: /* @__PURE__ */ e([
      "list-style-type:none;"
    ])
  },
  border: /* @__PURE__ */ e([
    "border-spacing:0;border:0;"
  ])
};
export {
  s as default
};
